import { render, staticRenderFns } from "./totalFilters.vue?vue&type=template&id=6c3e1b76"
import script from "./totalFilters.vue?vue&type=script&lang=js"
export * from "./totalFilters.vue?vue&type=script&lang=js"
import style0 from "./totalFilters.vue?vue&type=style&index=0&id=6c3e1b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports